// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__shuiU","header":"styles_header__Ao5HZ","searchBox":"styles_searchBox__s9k8t","candidateTable":"styles_candidateTable__nkB0T"};